.container {
  display: flex;
  flex-wrap: wrap;

  & h2 {
    width: 100%;
  }
}

.variableContainer {
  flex: 0 0 50%;
}

.variableHeader {
  text-transform: uppercase;
  padding-right: 1em;
}

.chartContainer {
  width: 350px;
  margin-bottom: 2em;
}

.titleRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.title {
  flex: auto;
}

.distributionLinkRow {
  text-align: right;
}
